import { render, staticRenderFns } from "./NoResultSaved.vue?vue&type=template&id=9b47f1c8&scoped=true&"
var script = {}
import style0 from "./NoResultSaved.vue?vue&type=style&index=0&id=9b47f1c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b47f1c8",
  null
  
)

export default component.exports